
import { defineComponent, computed, onMounted, getCurrentInstance } from "vue";

export default defineComponent({
	setup(props, context) {
		const instance = getCurrentInstance();
		const lang = computed(() => instance.proxy.$store.state.appCulture);

		const widgetOptions = {
			language: "it",
			chkPrivacyVisible: true,
			chkMarketingVisible: false,
			privacyPolicyLink: "https://www.k-digitale.com",
			marketingPolicyLink: ""
		};

		onMounted(() => {
			try {
				(window as any).initWEOnDemand("#kd-widget", widgetOptions);
			} catch (error) {
				console.log("Errore inizializzazione widget Expert On Demand: " + error);
			}
		});

		return {};
	}
});
